import configData from 'aws-config-data.json';

export const AWS_COGNITO_CONFIG = configData.aws_cognito;
